import { IDefineCommand, ICommand } from 'core-ts-types';

angular.module('capability-ng-user-app').factory(
  'validateTokenCommand',
  (defineCommand: IDefineCommand, $http: ng.IHttpService): ICommand => {
    return defineCommand('validateTokenCommand', function(deferred: ng.IDeferred<any>, token: string): void {
      $http({
        method: 'POST',
        url: 'auth/validate-token/',
        data: {
          token
        }
      })
        .then((response: ng.IHttpPromiseCallbackArg<any>): any => {
          if (response.data.results.valid) {
            window['$ip'].constants.upgrade({
              '@token': token
            });
            deferred.resolve(response.data);
          } else {
            deferred.reject();
          }
        })
        .catch(deferred.reject);
    });
  }
);



// WEBPACK FOOTER //
// ./app/lib/user_app/commands/validate_token_command.ts